import { isVideoPath } from "src/utils/imageUrl";

export const currencyMap = {
    usd: "$",
    eur: "€",
    gbp: "£",
    inr: "₹",
    jpy: "¥",
    cad: "C$",
    aud: "A$",
    nzd: "NZ$",
    php: "₱",
  };

export const sortingDropdownOptions = [
  { key: "dsc", value: "Default" },
  { key: "asc", value: "Price: Low to High" },
  { key: "desc", value: "Price: High to Low" },
];

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

// Address types
export const ADDRESS_TYPES = ['Home', 'Work', 'Other'];

export const methodDescriptions = {
  COD: "Pay with cash when your order arrives",
  UPI: "Pay using GPay, PhonePe, or other UPI apps",
  Razorpay: "Pay securely with credit/debit card or netbanking",
  Cashfree: "Pay by UPI, card, netbanking or wallet",
  Stripe: "Pay securely with Stripe",
  PayPal: "Pay with Debit/Credit Card or PayPal",
  PayMongo: "Pay by card, GCash, Maya or GrabPay",
};

export  const getImagePath = (images, variantId = null) => {
    if (!images || !Array.isArray(images) || images.length === 0) {
      return null;
    }

    if (variantId) {
      const variantImage = images.find(
        img => img?.variant_id === variantId && !isVideoPath(img?.imagePath)
      );
      if (variantImage?.imagePath) {
        return variantImage.imagePath;
      }
    }

    // Fallback to first available photo (videos can't render in <img> contexts)
    const firstImage = images.find(img => img?.imagePath && !isVideoPath(img.imagePath));
    return firstImage?.imagePath || null;
  };

/**
 * Formats a date string to a readable format with time like "April 30, 2024 at 2:30 PM"
 * @param {string} dateString - The date string from API
 * @returns {string} - Formatted date and time string
 */
export const formatPageDateTime = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }
    
    const dateOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    
    const timeOptions = {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
    
    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
    
    return `${formattedDate} at ${formattedTime}`;
  } catch (error) {
    console.error('Error formatting date and time:', error);
    return '';
  }
};


  // Helper function to format date
 export const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    return `${day} ${month}`
  };

  // Helper function to format time
 export const formatTimeForDisplay = (dateString) => {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

